// Post-authentication redirect helpers.
//
// The public marketing site (talentfora.in) can't know whether a visitor is
// signed in, so its "Get started" links hand the intent to the app and let the
// app decide where it belongs. When that lands on an auth page the intended
// destination travels as a `?next=` query param through register -> login.
//
// A `next` value comes from the URL, so it is attacker-controlled: never hand it
// to navigate()/window.location without running it through safeNextPath first,
// or the auth pages become an open redirect.

// Accepts only same-origin, absolute-path destinations:
//   "/subscribe/abc?currency=INR"  -> returned as-is
//   "//evil.com", "https://evil.com", "javascript:...", "dashboard" -> null
export function safeNextPath(value) {
  if (typeof value !== 'string') return null;
  const next = value.trim();
  if (!next.startsWith('/')) return null;
  // "//host" and "/\host" are protocol-relative URLs, not local paths.
  if (next.startsWith('//') || next.startsWith('/\\')) return null;
  return next;
}

// Appends `next` to an in-app auth path so the intent survives one more hop.
export function withNext(path, next) {
  const safe = safeNextPath(next);
  return safe ? `${path}?next=${encodeURIComponent(safe)}` : path;
}
